export const formatNumberInCurrency = (number, currency) => {
  const currencyFormatter = new Intl.NumberFormat(["en-US", "en-AU"], {
    currency,
    maximumFractionDigits: 2,
  });
  return currencyFormatter.format(number);
};
